import api from '@/services/Api'
import Badge from '@/services/Badge'

// ----------------------------- o

const namespaced = true;

// ----------------------------- o

const state = {
    errors: {},
    loading: false,
    details: localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : null,
    hash: '',
    new_phone_number: '',
    notifications: [],
    unread_notifications: 0,
    header_disabled: false,
    manuals: []
};

// ----------------------------- o

const getters = {
    getProfile: state => state.details,
};

// ----------------------------- o

const actions = {
    'PROFILE_REQUEST': ({commit, dispatch}, user) => {
        return new Promise((resolve, reject) => {
            commit('PROFILE_REQUEST');
            let url = 'users/profile';
            api({url: url, method: 'GET'})
                .then(resp => {
                    let profile = resp.data.data
                    commit('UPDATE_PROFILE', profile);
                    // get user specific data
                    dispatch('CONFIG_NAVIGATION_REQUEST', 1, {root: true});
                    dispatch('CONFIG_SETTINGS_REQUEST', 1, {root: true});
                    dispatch('PROFILE_NOTIFICATIONS_REQUEST');
                    resolve(resp)
                })
                .catch(err => {
                    commit('PROFILE_ERROR', err.response.data);
                    reject(err)
                })
        })
    },
    'UPDATE_PROFILE_NAME_REQUEST': ({commit, dispatch}, form) => {
        return new Promise((resolve, reject) => {
            commit('PROFILE_REQUEST');
            let url = 'users/profile/update/name';
            api({url: url, data: form, method: 'POST'})
                .then(resp => {
                    commit('UPDATE_PROFILE', form);
                    dispatch('GLOBAL_TOAST','Zaktualizowaliśmy Twoje dane.', {root:true})
                    resolve(resp)
                })
                .catch(err => {
                    commit('PROFILE_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'UPDATE_PROFILE_PHONE_REQUEST': ({commit, dispatch}, form) => {
        return new Promise((resolve, reject) => {
            commit('PROFILE_REQUEST');
            let url = 'users/profile/update/phone/verify';
            api({url: url, data: form, method: 'POST'})
                .then(resp => {
                    dispatch('GLOBAL_TOAST','Wysłano token SMS.', {root:true})
                    commit('VERIFY_PROFILE_NUMBER', resp.data.data)
                    resolve(resp)
                })
                .catch(err => {
                    commit('PROFILE_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'UPDATE_PROFILE_TOKEN_REQUEST': ({commit, dispatch}, form) => {
        return new Promise((resolve, reject) => {
            commit('PROFILE_REQUEST');
            let url = 'users/profile/update/phone';
            api({url: url, data: form, method: 'POST'})
                .then(resp => {
                    dispatch('GLOBAL_TOAST','Zmieniliśmy Twój numer telefonu.', {root:true});
                    commit('UPDATE_USER_PHONE_NUMBER');
                    resolve(resp)
                })
                .catch(err => {
                    commit('PROFILE_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'UPDATE_PROFILE_PASSWORD_REQUEST': ({commit, dispatch}, form) => {
        return new Promise((resolve, reject) => {
            commit('PROFILE_REQUEST');
            let url = 'users/profile/update/password';
            api({url: url, data: form, method: 'POST'})
                .then(resp => {
                    dispatch('GLOBAL_TOAST','Zaktualizowaliśmy Twoje hasło.', {root:true})
                    resolve(resp)
                })
                .catch(err => {
                    commit('PROFILE_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'PROFILE_PLACE_JOIN_REQUEST': ({commit, dispatch}, form) => {
        return new Promise((resolve, reject) => {
            commit('PROFILE_REQUEST');
            let url = 'places/join';
            api({url: url, data: form, method: 'POST'})
                .then(resp => {
                    dispatch('PROFILE_REQUEST'); // get updated profile
                    resolve(resp)
                })
                .catch(err => {
                    commit('PROFILE_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'PROFILE_AGREEMENTS_REQUEST': ({commit, dispatch}, form) => {
        return new Promise((resolve, reject) => {
            commit('PROFILE_REQUEST');
            let url = 'users/agreements/store';
            api({url: url, data: form, method: 'POST'})
                .then(resp => {
                    if(resp.data.message){
                        dispatch('GLOBAL_TOAST', resp.data.message, {root:true})
                    }
                    resolve(resp)
                })
                .catch(err => {
                    commit('PROFILE_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'PROFILE_NOTIFICATIONS_REQUEST': ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('PROFILE_REQUEST');
            let url = 'users/notifications?per_page=100';
            api({url: url, method: 'GET'})
                .then(resp => {
                    let notifications = resp.data.data
                    commit('UPDATE_PROFILE_NOTIFICATIONS', notifications);
                    commit('RECALCULATE_NOTIFICATIONS', true);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    'PROFILE_DISMISS_NOTIFICATION': ({commit, dispatch}, id) => {
        return new Promise((resolve, reject) => {
            commit('PROFILE_REQUEST');
            let url = 'users/notifications/'+ id +'/close';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('RECALCULATE_NOTIFICATIONS', true);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    'PROFILE_MANUALS': ({commit, dispatch}, id) => {
        return new Promise((resolve, reject) => {
            commit('PROFILE_REQUEST');
            let url = 'users/manuals';
            api({url: url, method: 'GET'})
                .then(resp => {
                    commit('PROFILE_SET_MANUALS', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    'PROFILE_LESSON_PASSED': ({commit, dispatch}) => {
        commit('UPDATE_PROFILE_LESSON_PASSED');
    }
};

// ----------------------------- o

const mutations = {
    'PROFILE_REQUEST': (state) => {
        state.errors = {};
        state.loading = true
    },
    'UPDATE_PROFILE': (state, profile) => {
        state.details = profile;
        state.loading = false;
        // save profile to local storage
        localStorage.setItem('profile', JSON.stringify(profile))
        // save user's first place as default
        if(profile && profile.places.length > 0){
            let default_sfa = profile.places[0].sfa
            localStorage.setItem('default_sfa', default_sfa)
        }
    },
    'UPDATE_PROFILE_NOTIFICATIONS': (state, notifications) => {
        state.notifications = notifications;
        state.loading = false;
    },
    'PROFILE_DISMISS_NOTIFICATION_SUCCESS': (state, value) => {
        state.notifications[value.index].isRead = value.bool;
    },
    'RECALCULATE_NOTIFICATIONS': (state, bool) => {
        setTimeout(()=> {
            // calculate unread
            state.unread_notifications = state.notifications.filter((o) => { return o.isRead == false; }).length
            // set badge
            Badge.setBadge(state.unread_notifications)
        }, 200);
    },
    'VERIFY_PROFILE_NUMBER': (state, resp) => {
        state.hash = resp.hash;
        state.new_phone_number = resp.phone_number;
        state.loading = false;
    },
    'UPDATE_USER_PHONE_NUMBER': (state) => {
        state.details.phone_number = state.new_phone_number;
        localStorage.setItem('profile', JSON.stringify(state.details)); // update local storage
        state.loading = false
    },
    'UPDATE_PROFILE_LESSON_PASSED': (state) => {
        state.details.number_pass_tests = state.details.number_pass_tests + 1; // add +1
    },
    'PROFILE_ERROR': (state, resp) => {
        state.errors = resp;
        state.loading = false
    },
    'PROFILE_SET_HEADER_DISABLED': (state, bool) =>{
        state.header_disabled = bool;
    },
    'PROFILE_SET_AGREEMENTS_REDIRECT': (state, bool) => {
        state.details.redirect_to_agreements = bool;
    },
    'PROFILE_REMOVE': (state) => {
        state.details = null;
    },
    'PROFILE_SET_MANUALS' : (state, resp) => {
        state.manuals = resp.data
        state.loading = false
    }
};

// ----------------------------- o

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}
